export const apiUrl = ((window._env_ && window._env_.API_URL)
    ? window._env_.API_URL
    : process.env.REACT_APP_API_ENTRYPOINT) ?? '';
export const mercureUrl = ((window._env_ && window._env_.MERCURE_SUBSCRIBE_URL)
    ? window._env_.MERCURE_SUBSCRIBE_URL
    : process.env.REACT_APP_MERCURE_HUB) ?? '';
